/* function addItemToCart(productId) { 
    let formData = {
        'items': [{
            'id': productId,
            'quantity': 1,
            'properties': {
                '_autocart': 'true',
                '_free-gift': 'true'
            }
        }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
        // Fetch the updated cart data
        return fetch(window.Shopify.routes.root + 'cart.js');
    })
    .then(response => response.json())
    .then(cartData => {
        // Update the cart sections
        updateCartSections();
    })
    .catch((error) => {
        console.error('Error adding item:', error);
    });
}

function updateCartSections() {
    const sections = ['main-cart-items','mini-cart','cart-icon-bubble','mobile-cart-icon-bubble'];
    fetch(`${window.Shopify.routes.root}cart?sections=${sections.join(',')}`)
        .then(response => response.json())
        .then(data => {
            sections.forEach(section => {
                const element = document.querySelector(`#${section}`);
                if (element && data[section]) {
                    if (section === 'main-cart-items') {
                        const tempContainer = document.createElement('div');
                        tempContainer.innerHTML = data[section];
                        const newContent = tempContainer.querySelector('.cart__items');
                        if (newContent) {
                            element.innerHTML = newContent.outerHTML;
                        } else {
                            console.warn(`Content for section ${section} not found in response.`);
                        }
                    } else {
                        element.innerHTML = data[section];
                    }
                } else {
                }
            });
        })
        .catch((error) => {
            console.error('Error updating cart sections:', error);
        });
}


function removeItemFromCart(productId) {
    let updates = {};
    updates[productId] = 0;

    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
    })
    .then(response => response.json())
    .then(data => {
        // Fetch the updated cart data
        return fetch(window.Shopify.routes.root + 'cart.js');
    })
    .then(response => response.json())
    .then(cartData => {
        // Update the cart sections
        updateCartSections();
    })
    .catch((error) => {
        console.error('Error removing item:', error);
    });
}

function checkCartTotal(cart) {
    const threshold = 7000; // 70€ en centimes (Shopify utilise les centimes)
    const productId = 45501151510753; // ID de l'article à ajouter

    if (cart.total_price > threshold) {
        // Vérifier si l'article est déjà dans le panier
        let itemExists = cart.items.some(item => item.id === productId);

        if (!itemExists) {
            addItemToCart(productId);
        }
    } else {
        // Si le total est inférieur au seuil, retirer l'article s'il est dans le panier
        let item = cart.items.find(item => item.id === productId);

        if (item) {
            removeItemFromCart(item.id);
        }
    }
}

document.addEventListener('ajaxProduct:added', function(evt) {
    // Récupérer les données mises à jour du panier
    fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(cartData => {
            // Appeler la fonction checkCartTotal avec les données du panier mises à jour
            checkCartTotal(cartData);
        })
        .catch((error) => {
            console.error('Error fetching cart data:', error);
        });
});

*/

function toggleFreeGiftSection(cart) {

  function updateGiftSection() {
    console.log("updateGiftSection appelé"); // Log pour vérifier l'appel de cette fonction
    const freeGiftSection = document.getElementById('free-gift-section');
    const freeGiftContainer = document.getElementById('freegiftblock');
    if (!freeGiftSection) {
      return;
    }

    // Vérifier si un article cadeau est déjà dans le panier
    const gift1 = cart.items.find(item => item.properties?._cadeau === "_offert1"); 
    const gift2 = cart.items.find(item => item.properties?._cadeau === "_offert2");
    const totalPrice = cart.total_price;
    
    // Affiche ou masque la section cadeau en fonction du total du panier et de la présence du cadeau
    if (totalPrice >= 8000 && !gift2) {
      freeGiftContainer.classList.add('show');
    } else if (totalPrice >= 5000 && !gift1) {
      freeGiftContainer.classList.add('show'); 
    } else {
      freeGiftContainer.classList.remove('show');
    }

    // Retirer l'article cadeau si le total est en dessous de 6000 et que le cadeau est présent
    if (totalPrice < 5000 && gift1) {
      removeGiftItemByCadeau(1);
    } else if (totalPrice < 8000 && gift2) {
      removeGiftItemByCadeau(2);
    }
  }

  // Vérifie si `freeGiftSection` existe déjà
  if (document.getElementById('free-gift-section')) {
    updateGiftSection();
  } else {
    // Crée un observateur pour détecter l'ajout de `#free-gift-section` au DOM
    const observer = new MutationObserver((mutationsList, observer) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList' && document.getElementById('free-gift-section')) {
          updateGiftSection();
          observer.disconnect(); // Arrête l'observateur après la détection
          break;
        }
      }
    });

    // Commence à observer le `body` pour l'ajout de nouveaux nœuds
    observer.observe(document.body, { childList: true, subtree: true });
  }
}


// Exécuter `toggleFreeGiftSection` au chargement de la page
document.addEventListener('DOMContentLoaded', function() {
    fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(cartData => {
            toggleFreeGiftSection(cartData); // Vérifier l'affichage de la section cadeau au chargement
        })
        .catch((error) => {
            console.error('Error fetching cart data:', error);
        });
});

// Re-vérifier l'affichage de la section cadeau après chaque ajout ou mise à jour du panier
document.addEventListener('ajaxProduct:added', function(evt) {
    fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(cartData => {
            toggleFreeGiftSection(cartData); // Vérifier l'affichage de la section cadeau
        })
        .catch((error) => {
            console.error('Error fetching cart data:', error);
        });
});

document.addEventListener('cart:updated', function(evt) {
    fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(cartData => {
            toggleFreeGiftSection(cartData); // Vérifier l'affichage de la section cadeau
        })
        .catch((error) => {
            console.error('Error fetching cart data:', error);
        });
});



function removeGiftItemByCadeau(propertyValue) {
  // Trouver l'article cadeau
  let giftItem;
  if (window.location.pathname === '/cart') {
    giftItem = document.querySelector(`tr.cart-item[data-cadeau${propertyValue}="true"]`); // Sur la page /cart
  } else {
    giftItem = document.querySelector(`[data-cadeau${propertyValue}="true"]`); // Dans le mini-cart
  }
  if (giftItem) {
    const lineIndex = giftItem.querySelector('cart-remove-button')?.dataset.index; // Récupérer l'index de ligne
    if (lineIndex) {

      // Appeler la méthode updateQuantity pour supprimer l'article
      const cartItemsElement = document.querySelector('cart-items');
      if (cartItemsElement && typeof cartItemsElement.updateQuantity === 'function') {
        cartItemsElement.updateQuantity(lineIndex, 0); // Supprime l'article (quantity = 0)
      } else {
        console.error("Élément cart-items ou méthode updateQuantity introuvable.");
      }
    } else {
      console.warn("Index de ligne introuvable pour l'article cadeau.");
    }
  } else {
    console.warn("Aucun article cadeau trouvé avec data-cadeau='true'.");
  }
}


